import { BookingStatus, BookingSeconStatus } from '~constants/reconciliationStatus';

export const getMainStatus = t => {
  // 该方法对应的状态  必须和翻译文件里顺序一样。。
  const result = {
    keys: Object.keys(BookingStatus),
    value: t('landlord.booking.reconciliation.details.stage.mainstatus').split(','),
    getValueByKey(key) {
      const index = result.keys.indexOf(key);
      return index > -1 ? result.value[index] : '';
    },
  };

  return result;
};

export const getSecondaryStatus = (status, t) => {
  // 该方法对应的状态  必须和翻译文件里顺序一样。。

  const keys = Object.keys(BookingSeconStatus);
  const values = t('landlord.booking.reconciliation.details.stage.status').split(',');

  const index = keys.indexOf(status);
  return index > -1 ? values[index] : '';
};
